import {
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Task, Piano, Message } from "@mui/icons-material";
import React from "react";
import "./styles.css";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Locale from "../../locales";
import { roles } from "../../constants/roles";
import {
  fetchPieces,
  fetchSessions,
  onTeacherScreenNavigation,
} from "../../redux/actions";

const useStyles = makeStyles({
  drawer: {
    width: "250px",
  },
  drawerPaper: {
    width: "250px",
  },
  sidebarHeader: {
    height: "44px",
    padding: "10px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F9F9F9",
  },
  sidebarHeaderText: {
    marginLeft: "12px",
  },
  listItemButton: {
    height: "70px",
  },
});

const Sidebar = ({ mobileOpen, handleDrawerToggle, window }) => {
  const currentStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );
  const role = useSelector((state) => state.authReducer.role);
  const history = useHistory();
  const location = useLocation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const isSmall = useMediaQuery("(max-width:1400px)");

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const managePiecesNavigationClicked = () => {
    dispatch(onTeacherScreenNavigation());
    history.push("/pieces");
    handleDrawerToggle();
    dispatch(fetchPieces(currentStudent));
  };

  const manageTasksNavigationClicked = () => {
    dispatch(onTeacherScreenNavigation());
    history.push("/tasks");
    handleDrawerToggle();
    dispatch(fetchSessions(currentStudent));
  };

  const drawer = (
    <>
      <Box display="flex" className={styles.sidebarHeader}>
        <img className="logo" src="/blobitLogo.png" alt="Blobit" />
        <h2 className={styles.sidebarHeaderText} variant="h6">
          {Locale.t("blobit")}
        </h2>
      </Box>
      <Divider />
      <List>
        {role === roles.TEACHER && (
          <ListItemButton
            className={styles.listItemButton}
            selected={location.pathname === "/tasks"}
            onClick={manageTasksNavigationClicked}>
            <ListItemIcon>
              <Task
                fontSize="large"
                color={location.pathname === "/tasks" ? "primary" : ""}
              />
            </ListItemIcon>
            <ListItemText primary={Locale.t("manage_tasks")} />
          </ListItemButton>
        )}
        {role === roles.TEACHER && (
          <ListItemButton
            className={styles.listItemButton}
            selected={location.pathname === "/pieces"}
            onClick={managePiecesNavigationClicked}>
            <ListItemIcon>
              <Piano
                fontSize="large"
                color={location.pathname === "/pieces" ? "primary" : ""}
              />
            </ListItemIcon>
            <ListItemText primary={Locale.t("manage_pieces")} />
          </ListItemButton>
        )}
        {role === roles.ADMIN && (
          <ListItemButton
            className={styles.listItemButton}
            selected={location.pathname === "/randomMessage"}
            onClick={() => history.push("/randomMessage")}>
            <ListItemIcon>
              <Message
                fontSize="large"
                color={location.pathname === "/randomMessage" ? "primary" : ""}
              />
            </ListItemIcon>
            <ListItemText primary={Locale.t("custom_messages")} />
          </ListItemButton>
        )}
      </List>
    </>
  );

  return (
    <nav className={styles.drawer}>
      {isSmall && (
        <Drawer
          container={container}
          variant="temporary"
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: styles.drawerPaper,
          }}
          ModalProps={{ keepMounted: true }}>
          {drawer}
        </Drawer>
      )}
      {!isSmall && (
        <Drawer
          classes={{
            paper: styles.drawerPaper,
          }}
          variant="permanent"
          open>
          {drawer}
        </Drawer>
      )}
    </nav>
  );
};

export default Sidebar;
